import { createStore } from "vuex";

const store = createStore({
  state: {
    token: null,
    user: null,

    
    collections: [],
    
    campaigns: [],
    

    
  },
  mutations: {
    clearToken(context) {
      context.commit("removeToken");
    },
    clearUser(context) {
      context.commit("removeUser");
    },
    addToken(context) {
      context.commit("setToken");
    },
    removeToken(context) {
      context.commit("removeToken");
    },

    
    setCollections(state, collections){
      state.collections=collections
    },

    setCampaigns(state, campaigns){
      state.campaigns=campaigns
    },
   
   
    
    


   
  },
  actions: {
    clearToken(context) {
      context.commit("removeToken");
    },
    clearUser(context) {
      context.commit("removeUser");
    },
    addToken(context) {
      context.commit("setToken");
    },

    
    async LoadCollections(context) {
      const url = `https://api.roberms.com/fundraise/get/fundraise/payments`;

      const response = await fetch(url, {
        mode: "cors",
        // credentials: "include",
        headers: {
          "Access-Control-Allow-Origin": true,
        },
      });
      const responseData = await response.json();
      if (!response.ok) {
        //
      }
      const clients = [];
      for (const key in responseData) {
        const client = {
          
          id: key,
          TransID: responseData[key].TransID,
          TransAmount: responseData[key].TransAmount,

          MSISDN: responseData[key].MSISDN,
          FirstName: responseData[key].FirstName,
          display_names: responseData[key].display_names,
          OrgAccountBalance: responseData[key].OrgAccountBalance,
          clinet_name: responseData[key].clinet_name,
          clinet_code: responseData[key].clinet_code,
          payment_reference: responseData[key].payment_reference,
          payment_date: responseData[key].payment_date,
         

          
          processed: responseData[key].processed,
        };
        clients.push(client);
      }
      context.commit("setCollections", clients);
    },

    async LoadCampaigns(context) {
      const url = `https://api.roberms.com/fundraise/get/campaigns`;

      const response = await fetch(url, {
        mode: "cors",
        // credentials: "include",
        headers: {
          "Access-Control-Allow-Origin": true,
        },
      });
      const responseData = await response.json();
      if (!response.ok) {
        //
      }
      const campaigns = [];
      for (const key in responseData) {
        const campaign = {
          
          id: key,

          name: responseData[key].name,
          client_id: responseData[key].client_id,

          paybill_account: responseData[key].paybill_account,
          message: responseData[key].message,
          amount_contributed: responseData[key].amount_contributed,
          total_expenses: responseData[key].total_expenses,
          balance: responseData[key].balance,
          reg_date: responseData[key].reg_date,
          is_active: responseData[key].is_active,
         

          
          // processed: responseData[key].processed,
        };
        campaigns.push(campaign);
      }
      context.commit("setCampaigns", campaigns);
    },

   


    

    
  
  
  
  

   
  
  },
  getters: {
    isLoggedIn() {
      return !!localStorage.getItem("token");
    },

   
    
    collections: (state) => state.collections,
    allCampaigns: (state) => state.campaigns,
  
    
    

    has_loan: (state)=>(id)=>state.loans.filter(number=>number.id_number==id),

    isLoanCleared: (state) => () => {
      const loan = state.loans.find(loan => loan.id_number === 	
        '254467890');
      return loan && loan.status === 'cleared';
    },

  },
  


  //
});
export default store;